import React from 'react';
import {observer} from 'mobx-react-lite';

import ForceUpgradeScreenContent from './ForceUpgradeScreenContent';
import {useForceUpgradeVersion} from './useForceUpgradeVersion';

/**
 * Container component for the force upgrade screen
 * Fetches version data via hook and passes to presentational component
 */
const ForceUpgradeScreen = observer(() => {
  const {currentVersion, minimumVersion, onUpdatePress} = useForceUpgradeVersion();

  return (
    <ForceUpgradeScreenContent
      currentVersion={currentVersion}
      minimumVersion={minimumVersion}
      onUpdatePress={onUpdatePress}
    />
  );
});

export default ForceUpgradeScreen;
